/************
 * Model Class
 * File Name ...: message-definition.components.ts
 * Generated By : ianday on 1/9/24
 * Date ........: 1/9/24
 /************/
import {ValidationResult} from './validation-result';

export interface MessageDefinition {

    id: number;
    description: string | null;
    messageCategory: string | null;
    subject: string | null;
    messageBody: string | null;
    activeStatus: string | null;
}

export class MessageDefinition {
    constructor() {
        this.id = 0;
        this.description = '';
        this.messageCategory = '';
        this.subject = '';
        this.messageBody = '';
        this.activeStatus = '';
    }

    validateRecord(): ValidationResult {
        const vr: ValidationResult = new ValidationResult();

        if (this.description.length === 0) {
            vr.focus_field = 'description';                              /* this should be the id value of the field */
            vr.error = 'Error: a description / value is required';
            return vr;
        }
        if (this.messageCategory.length === 0) {
            vr.focus_field = 'messageCategory';                              /* this should be the id value of the
             field */
            vr.error = 'Error: a message category / value is required';
            return vr;
        }
        if (this.subject.length === 0) {
            vr.focus_field = 'subject';                              /* this should be the id value of the field */
            vr.error = 'Error: a subject / value is required';
            return vr;
        }
        if (this.messageBody.length === 0) {
            vr.focus_field = 'messageBody';                              /* this should be the id value of the field */
            vr.error = 'Error: The message body cannot be blank';
            return vr;
        }
        return vr;
    }
}
